import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Dropzone from 'react-dropzone'
import cx from 'classnames'

import DEFAULT_AVATAR from 'images/DEFAULT_PROFILE_IMAGE.svg'
import DEFAULT_AVATAR_ON_HOVER from 'images/DEFAULT_PROFILE_IMAGE_ON_HOVER.svg'

import './style.css'

const ExistingAvatar = ({ url }) => <div className='avatar-image' style={{ backgroundImage: `url(${ url })`}} />

class UIDropArea extends Component {
  static defaultProps = {
    user: {}
  }

  static propTypes = {
    uploadAvatar: PropTypes.func.isRequired
  }

  state = {
    dropZoneHover: false
  }

  handleDrop = file =>
    this.props.uploadAvatar(file)

  handleMouseEnter = () =>
    this.setState({dropZoneHover: true})

  handleMouseLeave = () =>
    this.setState({dropZoneHover: false})

  render() {
    const { profile, stagedProfilePicture } = this.props
    const defaultAvatar = this.state.dropZoneHover ? <img src={DEFAULT_AVATAR_ON_HOVER} alt='Default Avatar'/> : <img src={DEFAULT_AVATAR} alt='Default Avatar'/>
    const Avatar = profile.coverPhotoUrl
      ? <ExistingAvatar url={profile.coverPhotoUrl}/>
      : stagedProfilePicture
        ? <ExistingAvatar url={stagedProfilePicture.preview} />
        : defaultAvatar

    return (
      <div>
        <span className='ui-drop-area-add-photo'>Add a photo of yourself</span>
        <div
            onMouseEnter={this.handleMouseEnter}
            onMouseLeave={this.handleMouseLeave}
            className={cx('file-dropzone', {'file-dropzone-hover': this.state.dropZoneHover})}
        >
          <Dropzone
            accept="image/jpeg, image/png"
            onDrop={(file) => this.handleDrop(file)}
            className='profile-avatar-old-dropzone'>
            <div className='profile-avatar-upload'>
              <div className='ui-drop-area-avatar'>
                {profile.isUploadingCoverPhoto ? <div className="spinner inline-loading" /> : Avatar}
              </div>
              <div className='profile-avatar-upload-info'>
                <span className='profile-avatar-upload-text'>
                  Pro Tip: Your photo should be at least 800x800
                </span>

                <span>
                  <span className='profile-avatar-upload-button'>+ Upload Photo</span>
                  <span className='profile-avatar-dnd-text'> or Drag and Drop Photo</span>
                </span>
              </div>
            </div>
          </Dropzone>
        </div>
      </div>
    )
  }
}

export default UIDropArea
